/*
 * DD AdminUI
 * Copyright (C) Fraunhofer IESE 2019 - 2025 Stefan Schweitzer, Shyalan Ramesh, Rafael Aranda López King,
 * Florian Wege, Johannes Schneider, Kazi Rezoanur Rahman, Christoph Müller, Pedram Jokar,
 * Mher Ter-Tovmasyan, Ben Burkhard, Matthias Gerbershagen, Anna Kleiner, Muhammad Tariq,
 * Adeline Silva Schäfer
 *
 * SPDX-License-Identifier: Apache-2.0
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import React from 'react';
import { Box, Typography } from '@mui/material';
import { Theme } from '@mui/material/styles';
import { WithStyles } from '@mui/styles';
import createStyles from '@mui/styles/createStyles';
import withStyles from '@mui/styles/withStyles';
import CategoryInfoView from './CategoryInfo.view';

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-unused-vars
const styles = (theme: Theme) => {
	return createStyles({
		categoryInfoContainer: {
			maxWidth: 500
		}
	});
};

interface Props extends WithStyles<typeof styles> {
	name: string;
	description: string;
	id: string;
	internalName: string;
}

function CategoryNameView(props: Props): React.ReactElement {
	const { name, description, id, internalName, classes } = props;

	return (
		<Box display="flex" flexDirection="row" alignItems="center">
			<Box pr={0.5}>{name}</Box>
			{(description || id || internalName) && (
				<CategoryInfoView>
					{/* {withStyles(styles)(({ classes }: Props) => ( */}
					<div className={classes.categoryInfoContainer}>
						{description && (
							<Box mb={3}>
								<Typography variant="body2">{description}</Typography>
							</Box>
						)}
						{id && (
							<div>
								<Typography variant="body2">{`ID: ${id}`}</Typography>
							</div>
						)}
						{internalName && (
							<div>
								<Typography variant="body2">{`Interner Name: ${internalName}`}</Typography>
							</div>
						)}
					</div>
					{/* ))} */}
				</CategoryInfoView>
			)}
		</Box>
	);
}

export default withStyles(styles)(CategoryNameView);
